import {
  EmptyStateNoResultIllustration,
  EmptyState,
  EmptyStateActions,
  EMPTY_STATE_MAX_WIDTH_CONTAINER_SELECTOR,
  EmptyStateProps,
} from '@ardoq/status-ui';
import { EmptyStatesDoqContainer } from '@ardoq/graph';
import styled from 'styled-components';
import { FlexBox } from '@ardoq/layout';
import { colors } from '@ardoq/design-tokens';

const Container = styled(EmptyStatesDoqContainer)`
  position: absolute;
  inset: 0;
  z-index: 1;
  background-color: ${colors.surfaceDefault};
  ${EMPTY_STATE_MAX_WIDTH_CONTAINER_SELECTOR} {
    max-width: 650px;
  }
`;
export const EmptyStateLayout = ({
  media = <EmptyStateNoResultIllustration />,
  title,
  description,
  children,
}: EmptyStateProps) => (
  <Container>
    <EmptyState media={media} title={title} description={description}>
      {children && (
        <EmptyStateActions>
          <FlexBox gap="small">{children}</FlexBox>
        </EmptyStateActions>
      )}
    </EmptyState>
  </Container>
);
